import React from 'react'
import { Table, Message, Badge, Modal, Input } from 'antd'
import {
  getBatchDetail,
  getMainDetail,
  destroyRecord,
} from '../../../api/businessCommodity'
import { toNormalTime } from '../../../util/index'
import MultiTable from './multiTable'

export default class extends React.Component {
  state = {
    mainList: [],
    batchList: [],
    description: '',
  }

  componentDidMount() {
    const listingId = this.props.allData.commodity.id
    this.getMainList(listingId)
  }

  getMainList = async (listingId) => {
    const { data, status, detail } = await getMainDetail(listingId)
    if (status == 1) {
      this.setState({ mainList: data })
    } else {
      Message.error(detail)
    }
  }

  openMultiTable = async (expanded, record) => {
    if (expanded) {
      const { listingId, id } = record
      const { data, status, detail } = await getBatchDetail(id)
      if (status == 1) {
        // this.setState({
        //   batchList: data,
        // })
        record.batchList = data
      } else {
        Message.error(detail)
      }
      console.log(this.state.mainList)
      this.forceUpdate()
    }
  }

  destroyData = async (record) => {
    const batchIds = []
    batchIds.push(record.id)
    const { data, status, detail } = await destroyRecord({
      batchIds: batchIds,
      description: this.state.description,
    })
    if (status == 1) {
      Message.success('销毁成功')
      const listingId = this.props.allData.commodity.id
      this.getMainList(listingId)
    } else {
      Message.error(detail)
    }
  }

  // 输入销毁原因
  askDestroyReason = (record) => {
    this.setState({
      askingData: record,
      isAsking: true,
    })
  }

  onAskOk = () => {
    if (this.state.description) {
      this.destroyData(this.state.askingData)
      this.setState({ isAsking: false })
    } else {
      Message.error('请输入销毁原因')
    }
  }

  onAskCancel = () => {
    this.setState({
      isAsking: false,
      askingData: {},
    })
  }

  render() {
    const expandedRowRender = (record, index, indent, expanded) => {
      const batchColumns = [
        {
          title: 'id',
          dataIndex: 'listingId',
          key: 'listingId',
          render: ($text, $record, $index) => {
            return $record.store.id
          },
        },
        {
          title: '所在仓库',
          dataIndex: ['store', 'name'],
          key: 'store',
          render: ($text, $record, $index) => {
            return $record.store.name
          },
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
          render: ($text, $record, $index) => {
            return (
              <Badge offset={[5, 2]} dot={$record.isStockWarning == true}>
                {$text}
                {$record.isStockWarning == true ? (
                  <span style={{ color: 'red' }}> (缺货)</span>
                ) : (
                  ''
                )}
              </Badge>
            )
          },
        },
      ]

      return (
        <MultiTable
          batchColumns={batchColumns}
          batchList={record.batchList}
          record={record}
          tableStatus="details"
        ></MultiTable>
      )
    }

    const mainColumns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '批次号',
        dataIndex: 'batchNumber',
        key: 'batchNumber',
      },
      {
        title: '库存数',
        dataIndex: 'quantity',
        key: 'quantity',
      },
      {
        title: '入货时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record, index) => {
          return toNormalTime(text)
        },
      },
      {
        title: '过期时间',
        dataIndex: 'expirationDate',
        key: 'expirationDate',
        render: (text, record, index) => {
          if (text == '1970-01-01') {
            return '无'
          } else {
            return text
          }
        },
      },
      {
        title: '成本总价(元)',
        dataIndex: 'totalCost',
        key: 'totalCost',
        render: (text, record, index) => {
          return ((record.unitCost * record.quantity) / 100).toFixed(2)
        },
      },
      {
        title: '操作人',
        dataIndex: 'operatorName',
        key: 'operatorName',
      },
      {
        title: '操作',
        dataIndex: 'handling',
        key: 'handling',
        render: (text, record, index) => {
          if (record.state == 1) {
            return '已销毁'
          } else {
            return (
              // <a
              //   onClick={() => {
              //     this.destroyData(record)
              //   }}
              // >
              //   销毁
              // </a>
              <a
                onClick={() => {
                  this.askDestroyReason(record)
                }}
              >
                销毁
              </a>
            )
          }
        },
      },
    ]

    return (
      <div>
        <Table
          bordered
          columns={mainColumns}
          expandable={{
            expandedRowRender,
            defaultExpandedRowKeys:
              this.state.mainList && this.state.mainList.length == 1
                ? this.state.mainList[0].id
                : null,
            onExpand: (expanded, record) => {
              this.openMultiTable(expanded, record)
            },
            rowExpandable: (record) => {
              if (record.state == 1) {
                return false
              } else {
                return true
              }
            },
          }}
          dataSource={this.state.mainList}
          size="small"
          rowKey="id"
        />

        <Modal
          visible={this.state.isAsking}
          title="销毁原因"
          onOk={this.onAskOk}
          onCancel={this.onAskCancel}
        >
          <Input
            placeholder="请输入销毁原因"
            value={this.state.description}
            onChange={(e) => this.setState({ description: e.target.value })}
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/batchList.js